import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IServiceLevel extends IBaseEntity {
    id?: number;
    shortCode?: string;
    description?: string;
    noOfDays?: number;
    minPallets?: number;
    maxPallets?: number;
    defaultService?: boolean;
}

export class ServiceLevel extends BaseEntity implements IServiceLevel {
    public id?: number;
    public shortCode?: string;
    public description?: string;
    public noOfDays?: number;
    public minPallets?: number;
    public maxPallets?: number;
    public defaultService?: boolean;

    constructor(serviceLevel?: any) {
        super();
        if (serviceLevel) {
            this.id = serviceLevel.id;
            this.shortCode = serviceLevel.shortCode;
            this.description = serviceLevel.description;
            this.noOfDays = serviceLevel.noOfDays;
            this.minPallets = serviceLevel.minPallets;
            this.maxPallets = serviceLevel.maxPallets;
            this.defaultService = serviceLevel.defaultService;
        }
    }

    get discriminator(): any {
        return this.shortCode;
    }

    clone(): ServiceLevel {
        return new ServiceLevel(this);
    }
}
